import { render, staticRenderFns } from "./joinLive.vue?vue&type=template&id=3f305ff4&scoped=true&"
import script from "./joinLive.vue?vue&type=script&lang=js&"
export * from "./joinLive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f305ff4",
  null
  
)

export default component.exports